import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo/clip.svg'


const _hoisted_1 = {
  class: "fixed top-0 left-0 w-screen h-screen flex justify-center items-center",
  style: {"z-index":"990"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full bg-black opacity-50" }, null, -1)
const _hoisted_3 = {
  class: "relative min-w-72 md:w-9/12 h-72 bg-white rounded-lg",
  style: {"z-index":"999"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full mt-7 bg-blue-00 flex justify-center text-lg font-bold" }, [
  /*#__PURE__*/_createElementVNode("p", null, "이벤트 공유하기")
], -1)
const _hoisted_5 = { class: "w-full bg-red-00 h-6/12 flex justify-center items-center space-x-10 mt" }
const _hoisted_6 = { class: "w-16 h-16 bg-[#FEE500] rounded-full flex justify-center items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "w-full justify-center flex mt-2 text-sm font-medium" }, "카카오톡", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-16 bg-[#E0F9F1] rounded-full flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "w-7 object-cover"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "w-full justify-center flex mt-2 text-sm font-medium" }, "링크공유", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { ref} from 'vue';
import KakaoShare from './KakaoShare.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ShareWays',
  props: {
  title : {type : String, required : true},
  date : {type : String, required : true},
  loca : {type : String, required : true},
  img : {type : String, required : true},
  link : {type : String, required : true},
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;
const closeByEmit = () =>{
    emits('close')
}
// 주소 복사하기 버튼
const linkText = ref(`https://padaapp.com/${props.link}`);
const handlCopy = () => {
    const textToCopy = linkText.value;
    navigator.clipboard.writeText(textToCopy).then(() => {
        alert('링크가 복사되었습니다.')
    })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(KakaoShare, {
              title: props.title,
              loca: props.loca,
              date: props.date,
              img: props.img,
              link: props.link
            }, null, 8, ["title", "loca", "date", "img", "link"])
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", { onClick: handlCopy }, _hoisted_10)
      ]),
      _createElementVNode("div", { class: "w-full bg-green-00 mt-2 justify-center flex h-4/12" }, [
        _createElementVNode("button", {
          class: "bg-pada w-10/12 h-10 rounded-md text-white font-bold",
          onClick: closeByEmit
        }, "닫기")
      ])
    ])
  ]))
}
}

})